<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_platformCode') || '渠道'"
            prop="platformCode"
          >
            <dict-select
              :value="platformTypeItem"
              :placeholder="$l('form_placeholder_platformCode') || '请选择渠道'"
              url="/ecom/hx/sku/platform/select"
              :options="{ label: 'label', value: 'this' }"
              filterable
              clearable
              @change="platformTypeChange"
              size="small"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_region') || '市场'">
            <el-input
              v-model="formData.regionName"
              :placeholder="$l('form_placeholder_region') || '请选择市场'"
              readonly
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt-1">
        <SkuTable ref="skuTable" :platformCode="formData.platformCode" />
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SkuTable from './table'
export default {
  mixins: [EditLoading],
  components: { SkuTable },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      rules: {
        platformCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    platformTypeItem() {
      const {
        regionCode,
        regionName,
        platformCode: value,
        platformName: label,
      } = this.formData
      return { regionCode, regionName, value, label }
    },
  },
  methods: {
    platformTypeChange(e) {
      const {
        regionCode,
        regionName,
        value: platformCode,
        label: platformName,
      } = e
      this.formData = {
        ...this.formData,
        regionCode,
        regionName,
        platformCode,
        platformName,
      }
    },
    async validate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const skuResult = await this.$refs.skuTable.validate()
      return formResult && skuResult
    },
    async putShelves() {
      if (!(await this.validate())) return (this.backDialogVisible = false)

      const listSku = this.$refs.skuTable.getTableData()
      const params = { ...this.formData, listSku }

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomHxSkuPlatformPutShelvesApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_put_shelves_failed') || '上架失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_put_shelves_success') || '上架成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
